export const STORE_LOGIN_PATHNAME = '/login';

export const STORE_REDIRECT_QUERY_PARAMS = {
    REDIRECT_LOGIN_TOKEN: 'redirect_login_token',
    JOURNEY_ID: 'journey_id',
    AUTO_COLLECT: 'auto_collect',
    POPUP_ID: 'popup_id',
} as const;
